export default "__VITE_PUBLIC_ASSET__47fea0ce__"